const faqs = [
  {
    id: 1,
    q: '51影视是否需要注册才能观看？',
    a: '不需要。51影视所有剧集均免费在线观看，无需注册、无需登录、无需付费，打开网站即可直接选择您想看的电视剧，随时随地畅享高清追剧体验。',
  },
  {
    id: 2,
    q: '播放时出现卡顿或缓冲怎么办？',
    a: '我们的播放器采用智能自适应码率技术，会根据您的网络状况自动调整清晰度。如遇卡顿，建议尝试切换播放线路（播放器右下角可选择备用线路），或稍等片刻让缓冲完成。',
  },
  {
    id: 3,
    q: '支持哪些设备观看电视剧？',
    a: '51影视全面支持电脑、平板和手机等设备。在电脑上可直接访问网站观看；手机和平板用户同样通过浏览器访问即可，无需额外下载APP。页面会自动适配您的设备屏幕尺寸。',
  },
  {
    id: 4,
    q: '剧集更新频率是怎样的？',
    a: '我们与各大视频平台保持同步更新。热门在播剧集通常于首播后24小时内上线最新集数，完结剧集一次性提供全集资源。建议关注首页"追剧快讯"栏目获取最新上架信息。',
  },
  {
    id: 5,
    q: '画质可以选择吗？支持多少清晰度？',
    a: '平台默认提供1080P全高清画质，同时支持720P、480P等多档清晰度切换。您可以在播放器设置中根据网络环境和设备性能自由选择合适的画质，平衡流畅度与清晰度。',
  },
  {
    id: 6,
    q: '如果找不到想看的剧集该怎么办？',
    a: '您可以通过"联络我们"模块发送剧集名称给我们，我们的内容团队会评估收录。由于版权与片源原因，部分剧集可能需要一定时间才能上线，感谢您的理解与耐心等待。',
  },
];

export default function Faq() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            常见问答
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            关于51影视的常见问题，这里都有答案
          </p>
        </div>

        <div className="max-w-3xl mx-auto flex flex-col gap-3 md:gap-4">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <div className="px-5 pt-4 pb-2">
                <h3 className="text-sm md:text-base font-medium text-foreground-800">
                  {faq.q}
                </h3>
              </div>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}